import api from "../../../core/api";
import {
  NotificationPreference,
  UpdateNotificationPreference,
} from "../models/notificationModels";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.notificationsApiBaseUrl };
};

class NotificationPreferencesApi {
  getPreferences(): Promise<NotificationPreference[]> {
    return api
      .get<NotificationPreference[]>(
        "/v1/customer/notification-preferences",
        getRequestConfig()
      )
      .then((x) => x.data);
  }

  updatePreferences(
    preferences: UpdateNotificationPreference[]
  ): Promise<void> {
    return api
      .put<void>(
        "/v1/customer/notification-preferences",
        preferences,
        getRequestConfig()
      )
      .then((x) => x.data);
  }
}

export default new NotificationPreferencesApi();
